import React from "react";
import ExpandingListItem from "./ExpandingListItem";
var ExpandingList = function (_a) {
    var items = _a.items;
    return (React.createElement("div", null, items.map(function (item, i) { return (React.createElement(ExpandingListItem, { item: item, key: i })); })));
};
ExpandingList.defaultProps = {
    items: []
};
export default ExpandingList;
